import React from 'react';
import {
  Box,
  Container,
  Typography,
  Chip,
  useMediaQuery,
  useTheme,
} from "@mui/material";

const PageBanner = ({ 
  title, 
  subtitle, 
  chipLabel, 
  bgImage, 
  gradient,
  icon 
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        position: "relative",
        pt: { xs: 12, sm: 14, md: 16 },
        pb: { xs: 6, sm: 8, md: 10 },
        // minHeight: { xs: "350px", md: "450px" },
         minHeight: { xs: "auto", md: "100vh" },
        display: "flex",
        alignItems: "center",
        overflow: "hidden",
      }}
    >
      {/* Background Image */}
      {bgImage && (
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            backgroundImage: `url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundAttachment: "fixed",
            zIndex: 0,
             objectFit: "cover",
            //  backgroundAttachment: { xs: "scroll", md: "fixed" },
          }}
        />
      )}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background:"linear-gradient(to right, rgba(121, 74, 52, 0.67) 35%, rgba(149, 83, 48, 0.41) 100%)",
          zIndex: 1,
        }}
      />

      {/* Decorative Circles */}
      <Box
        sx={{
          position: "absolute",
          top: -150,
          right: -150,
          width: 400,
          height: 400,
          borderRadius: "50%",
          background: "rgba(255,255,255,0.04)",
          zIndex: 1,
        }}
      />
      <Box
        sx={{
          position: "absolute",
          bottom: -150,
          left: -150,
          width: 400,
          height: 400,
          borderRadius: "50%",
          background: "rgba(255,255,255,0.04)",
          zIndex: 1,
        }}
      />

      <Container maxWidth="xl" sx={{ position: "relative", zIndex: 2, px: { xs: 2, sm: 3, md: 4 } }}>
        <Box sx={{ textAlign: "center", maxWidth: "800px", mx: "auto" }}>
          {chipLabel && (
            <Chip
              label={chipLabel}
              sx={{
                bgcolor: "rgba(255,255,255,0.15)",
                color: "#fff",
                fontWeight: 800,
                fontSize: { xs: "10px", md: "12px" },
                letterSpacing: "2px",
                px: 2,
                py: 0.5,
                mb: 2,
                backdropFilter: "blur(10px)",
                border: "1px solid rgba(255,255,255,0.1)",
              }}
            />
          )}

          {/* Icon - Only show if provided */}
          {icon && (
            <Box
              sx={{
                width: { xs: 64, md: 80 },
                height: { xs: 64, md: 80 },
                borderRadius: "50%",
                bgcolor: "rgba(255,255,255,0.15)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mx: "auto",
                mb: 2,
                backdropFilter: "blur(10px)",
              }}
            >
              {icon}
            </Box>
          )}

          <Typography
            sx={{
              fontWeight: 900,
              fontSize: { xs: "2rem", sm: "2.8rem", md: "3.5rem", lg: "4rem" },
              color: "#fff",
              lineHeight: 1.2,
              mb: subtitle ? 2 : 0,
              textShadow: "0 2px 20px rgba(0,0,0,0.15)",
            }}
          >
            {title}
          </Typography>

          {subtitle && (
            <Typography
              sx={{
                color: "rgba(255,255,255,0.95)",
                fontSize: { xs: "15px", sm: "16px", md: "18px" },
                maxWidth: "700px",
                mx: "auto",
                lineHeight: 1.8,
                textShadow: "0 1px 10px rgba(0,0,0,0.1)",
              }}
            >
              {subtitle}
            </Typography>
          )}
        </Box>
      </Container>
    </Box>
  );
};

export default PageBanner;